module.exports = __webpack_public_path__ + "static/img/naniungo-vacancy-banner.e85e8029.jpg";